<p class="title">
    {{ getText(question.globalizationConfig, "title") }}
</p>
<ion-list>
    <ion-item
            *ngFor="
                                let opValue of question.typeConfig.possibleValues;
                                let vIndex = index
                              ">
        <ion-label class="description-modal">
            {{ getTextGlobalized(question.typeConfig.possibleValuesGlobalized, vIndex) }}
            <ion-icon
                    *ngIf="typeConfigDescriptionEnabled && question.typeConfig.description && question.typeConfig.description[selectedLanguage][vIndex]"
                    class="bp-question-fill"
                    [matTooltip]="descriptionTooltip"
                    (mouseenter)="setTooltip(question, vIndex)"
                    (click)="openDescriptionConcept(question.typeConfig.possibleValuesGlobalized[selectedLanguage], question.typeConfig.description[selectedLanguage], vIndex)">
            </ion-icon>
                <ng-container
                    *ngIf="showRequiredBadge(formGroup, question.currentIndex)">
                <p class="required">
                    ({{ "generic.obligatoryField" | translate }})
                </p>
            </ng-container>
        </ion-label>
        <ion-checkbox
                slot="end"
                [disabled]="formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.disabled"
                [checked]="isCheckedMultiselect(question, opValue)"
                (ionChange)="onMultiSelectionChange($event, opValue, 'field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))"
        >
        </ion-checkbox>
    </ion-item>
</ion-list>